import { util, shapes } from '@clientio/rappid';
import { InputAttributes } from './input.attributes';

export class InputShape extends shapes.standard.Rectangle {
  defaults(): object {
    return util.defaultsDeep(InputAttributes, shapes.standard.Rectangle.prototype.defaults);
  }
}
